import { ref as i, watch as u } from "vue";
import p from "./index712.js";
import o from "./index703.js";
const s = {
  label: "label",
  value: "value",
  disabled: "disabled",
  options: "options"
};
function m(l) {
  const t = i({ ...s, ...l.props });
  let a = { ...l.props };
  return u(
    () => l.props,
    (e) => {
      p(e, a) || (t.value = { ...s, ...e }, a = { ...e });
    },
    { deep: !0 }
  ), {
    aliasProps: t,
    getLabel: (e) => o(e, t.value.label),
    getValue: (e) => o(e, t.value.value),
    getDisabled: (e) => o(e, t.value.disabled),
    getOptions: (e) => o(e, t.value.options)
  };
}
export {
  s as defaultProps,
  m as useProps
};
